const partners = [
  { name: "Dell Technologies", size: "text-xl" },
  { name: "Lenovo", size: "text-3xl" },
  { name: "Veeam", size: "text-2xl" },
  { name: "Nutanix", size: "text-2xl" },
  { name: "Fortinet", size: "text-2xl" },
  { name: "Trend Micro", size: "text-xl" },
  { name: "SUSE", size: "text-3xl" },
  { name: "Extreme", size: "text-2xl" },
  { name: "AWS", size: "text-3xl" },
  { name: "Zadara", size: "text-2xl" },
  { name: "HackOne", size: "text-2xl" },
  { name: "Zabbix", size: "text-2xl" },
  { name: "GLPI", size: "text-2xl" },
  { name: "PS TaxTech", size: "text-xl" },
  { name: "Microsoft", size: "text-2xl" },
];

export default function PartnersSection() {
  return (
    <section id="parceiros" className="py-20 bg-[#000000]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest mb-4" style={{ color: '#62A9E0' }}>
            <div className="w-6 h-px" style={{ background: 'linear-gradient(to right, #62A9E0, #4C86C2)' }}></div>
            Parceiros
            <div className="w-6 h-px" style={{ background: 'linear-gradient(to right, #62A9E0, #4C86C2)' }}></div>
          </div>
          <h2 className="text-4xl font-black text-white mb-4">
            Ecossistema de{" "}
            <span className="solus-gradient-text">parceiros</span>{" "}
            certificados
          </h2>
          <p className="text-white/55 max-w-xl mx-auto text-sm">
            Trabalhamos com as principais fabricantes de tecnologia do mundo para entregar as melhores soluções ao seu negócio.
          </p>
        </div>

        <div className="grid grid-cols-3 md:grid-cols-5 gap-4">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="rounded-lg px-4 py-6 flex items-center justify-center transition-all duration-300 cursor-default group"
              style={{
                background: 'rgba(255,255,255,0.03)',
                border: '1px solid rgba(98,169,224,0.15)',
              }}
              onMouseEnter={(e) => {
                const el = e.currentTarget as HTMLDivElement;
                el.style.borderColor = 'rgba(98,169,224,0.5)';
                el.style.background = 'rgba(98,169,224,0.06)';
              }}
              onMouseLeave={(e) => {
                const el = e.currentTarget as HTMLDivElement;
                el.style.borderColor = 'rgba(98,169,224,0.15)';
                el.style.background = 'rgba(255,255,255,0.03)';
              }}
            >
              <span
                className={`${partner.size} font-black tracking-tight text-center leading-tight text-white/70 group-hover:text-white transition-colors`}
              >
                {partner.name}
              </span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          className="mt-12 rounded-lg p-8 flex flex-col md:flex-row items-center justify-between gap-6"
          style={{ background: 'rgba(98,169,224,0.06)', border: '1px solid rgba(98,169,224,0.2)' }}
        >
          <div>
            <h3 className="text-xl font-bold text-white mb-2">Seja um parceiro Solus IT</h3>
            <p className="text-sm text-white/55">
              Junte-se ao nosso ecossistema e amplie as possibilidades de negócios com soluções de ponta.
            </p>
          </div>
          <a
            href="mailto:comercial@solus-it.com.br"
            className="px-6 py-3 solus-btn-primary font-semibold rounded-md text-sm cursor-pointer whitespace-nowrap solus-glow-sm"
          >
            Entrar em contato
          </a>
        </div>
      </div>
    </section>
  );
}
